import type { Auth0ContextInterface, User } from '@auth0/auth0-react';

let client: Auth0ContextInterface<User> | null = null;

export const authService = {
  setClient(auth0Client: Auth0ContextInterface<User>): void {
    client = auth0Client;
  },

  getClient(): Auth0ContextInterface<User> | null {
    return client;
  },

  async getAccessToken(): Promise<string | null> {
    if (!client) return null;
    try {
      return await client.getAccessTokenSilently();
    } catch {
      return null;
    }
  },

  isAuthenticated(): boolean {
    return client?.isAuthenticated ?? false;
  },
};
